export enum EntryFieldsDefaults {
  NAME = "name",
  EMAIL = "email",
  PHONE = "phone",
  MESSAGE = "message",
  DESCRIPTION = "description",
  COMPANY = "company",
  //
  FORM = "form",
  SOURCE = "source",
  CREATED = "created",
}
